import { TextField } from '@mui/material'
import { useDebounce } from 'hooks/useDebounce'
import InterventionListTable from 'modules/interventionList/components/InterventionListTable/InterventionListTable'
import { ReactElement, useState } from 'react'
import styled from 'styled-components'

export default function ArtisanInterventionList(): ReactElement {
  const [search, setSearch] = useState<string>()

  const textSearched = useDebounce(search, 500)

  return (
    <Wrapper>
      <TextField
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Rechercher une intervention"
        style={{ display: 'flex', width: '50%' }}
      />
      <InterventionListTable search={textSearched} filterBase={{}} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 50px;
`
